module.exports = function (element) {
    function shareBlock(el) {
        var node = $(el);
        var block = $('.js-size-block');

        node.on({
            click: function () {
                gtag('event', 'size_open', {
                    'event_category': 'size'
                });

                block.toggle();
                node.find('span').toggleClass('wallpaper__download__rbut__select__up')

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    shareBlock(element);
};